const email =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
const password = /^[A-Za-z\d#$@!%&*?]{4,60}$/;
const number = /^[0-9]+$/;
const float = /^[0-9]*([.][0-9]{0,2})?$/;
const urlName = /^[A-Za-z0-9-]+$/;

export default {
  email,
  password,
  number,
  float,
  urlName,
};
